<template>
    <v-container class="ma-0 pa-0">
        <v-row class="mb-5 v-sidebar__gallery" v-bind:class="{ 'only-one': galleryImages.length === 1 }">
            <v-col v-if="$lds.isEmpty(galleryImages)" class="">
                <v-skeleton-loader type="image" width="100%" height="360" style="margin-bottom: 4px"></v-skeleton-loader>
                <v-skeleton-loader v-if="galleryImages.length >= 2" type="image" width="100%" height="87"></v-skeleton-loader>
            </v-col>
            <v-col v-else>
                <VueSlickCarousel v-bind:asNavFor="gSlider2" v-bind="gHerosOption" class="overflow-hidden v-sidebar__gallery-heros">
                    <div v-for="(photo, i) in galleryImages" v-bind:key="`C-${i}`" class="c-pointer v-sidebar__gallery-image">
                        <img v-bind:src="photo" draggable="false" width="100%" alt="preview" class="img-fluid" />
                    </div>
                </VueSlickCarousel>
                <VueSlickCarousel
                    v-if="galleryImages.length > 1"
                    v-bind:asNavFor="gSlider1"
                    v-bind="gThumbsOption"
                    class="overflow-hidden v-sidebar__gallery-thumbs"
                >
                    <div v-for="(photo, i) in galleryImages" v-bind:key="`C-${i}`" class="c-pointer v-sidebar__gallery-image">
                        <img v-bind:src="photo" draggable="false" width="100%" alt="preview thumbnail" class="img-fluid" />
                    </div>
                </VueSlickCarousel>
            </v-col>
        </v-row>
        <!-- <div class="mt-2 mb-5" v-if="guideId">
            <button
                style="width: 100%; padding: 10px 0; border: none; background-color: #1279bd; color: #fff; font-size: 14px; text-align: center"
                class="tmpl-download"
                type="button"
                @click.stop="showGuide(guideId)"
            >
                템플릿 다운로드
            </button>
        </div> -->
    </v-container>
</template>

<script>
    import VueSlickCarousel from 'vue-slick-carousel';

    export default {
        name: 'ProductGallery',

        props: {
            productDetails: {
                type: Object, //
                default: () => ({}),
            },
            galleryImages: {
                type: Array,
                required: true, //
                default: () => [],
            },
        },

        components: {
            VueSlickCarousel,
        },

        watch: {
            productDetails: {
                immediate: true,
                handler(newVal) {},
            },
            galleryImages: {
                handler(newVal) {
                    if (!this.$lds.isEmpty(newVal)) {
                        this.$nextTick(() => {
                            this.gSlider1 = this.$refs.gCarousel1;
                            this.gSlider2 = this.$refs.gCarousel2;
                        });
                    }
                },
            },
        },

        data: () => ({
            gSlider1: null,
            gSlider2: null,
            // guideId: null,
            gHerosOption: {
                ref: 'gCarousel1',
                lazyLoad: 'ondemand',
                infinite: true,
                autoplay: true,
                autoplaySpeed: 5000,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                focusOnSelect: true,
                pauseOnHover: true,
                arrows: false,
            },
            gThumbsOption: {
                ref: 'gCarousel2',
                lazyLoad: 'ondemand',
                infinite: true,
                speed: 500,
                slidesToShow: 4,
                slidesToScroll: 1,
                focusOnSelect: true,
                swipeToSlide: true,
                arrows: false,
            },
        }),

        methods: {
            // handleTemplateDownload(event) {
            //     if (typeof templateDownload === 'function') {
            //         templateDownload(event);
            //     }
            // },
        },
    };
</script>
